// extracted by mini-css-extract-plugin
export var arrow = "filter-group-title-module--arrow--6bUkp";
export var open = "filter-group-title-module--open--FMxWN";
export var title = "filter-group-title-module--title--BHsUK";